import React, { FC } from 'react';

interface utc {
  utcDate: Date;
}

interface dateObject {
  day: number;
  month: number;
  year: number;
  hours: number;
  minutes: number;
}

const convertToLocal = (utc) => {
  const date = new Date(utc);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return {
    day: day,
    month: month,
    year: year,
    hours: hours,
    minutes: minutes,
  };
};

export const UtcToLocal: FC<utc> = ({ utcDate }) => {
  const s = convertToLocal(utcDate);
  return <>{`${s.day}/${s.month}/${s.year} ${s.hours}:${s.minutes}`}</>;
};

export const UtcToLocalTime: FC<utc> = ({ utcDate }) => {
  if (!utcDate) return;
  const s = convertToLocal(utcDate);
  return <>{` ${s.hours}:${s.minutes}`}</>;
};
